module.exports = __webpack_public_path__ + "img/grin.295b12ab.svg";